import type {
  ColorOption,
  GroupedColorOptions,
} from "./SelectColorInput.types";

const RAL_CODE_REGEX = /RAL (\d{4})/;

export function extractRalCode(
  value: string | null | undefined,
): string | null {
  const match = value?.match(RAL_CODE_REGEX);
  return match ? match[1] : null;
}

export function buildGroupedOptions(
  options: ColorOption[],
): GroupedColorOptions {
  const map: GroupedColorOptions = {};

  for (const opt of options) {
    const code = extractRalCode(opt.value);
    if (!code || code.length !== 4) {
      continue;
    }

    const f2 = code.slice(0, 2);
    const d3 = code[2];
    const d4 = code[3];

    if (!map[f2]) {
      map[f2] = {};
    }
    if (!map[f2][d3]) {
      map[f2][d3] = {};
    }

    map[f2][d3][d4] = opt;
  }

  return map;
}

export function sortedKeys(obj: Record<string, unknown>): string[] {
  return Object.keys(obj).sort();
}
